/**
 * The tray duck. Default export is the reducer.
 *
 * Action Types:
 * - TRAY_OPENED
 * - TRAY_CLOSED
 *
 * Action Creators:
 * - openTray
 * - closeTray
 */

import type { TrayAction, TrayOpened, TrayClosed, TrayState } from '../types';

/** @type {ActionType} */
export const TRAY_OPENED = 'PB/tray/TRAY_OPENED';

/** @type {ActionType} */
export const TRAY_CLOSED = 'PB/tray/TRAY_CLOSED';

/** @ignore */
export default function Tray(
  state: TrayState = {},
  action: TrayAction,
): TrayState {
  switch (action.type) {
    default:
      return state;
  }
}

export function openTray(
  vibeName: string,
  compName: string,
  additionalTrackingProps: any,
): TrayOpened {
  return {
    type: TRAY_OPENED,
    payload: {
      vibe_name: vibeName,
      comp_name: compName,
      additionalTrackingProps,
    },
  };
}

export function closeTray(
  vibeName: string,
  compName: string,
  additionalTrackingProps: any,
): TrayClosed {
  return {
    type: TRAY_CLOSED,
    payload: {
      vibe_name: vibeName,
      comp_name: compName,
      additionalTrackingProps,
    },
  };
}
